import { useQuery } from '@tanstack/react-query'

import { AxiosError } from 'axios'
import { ErrorHandling } from '../../../@types/ErrorHandling'
import {
  RunPetisSimulationClientRequest,
  RunPetisSimulationClientResponse,
} from '../../../@types/RunPetisSimulation'
import { api } from '../../../Services/API'
import { API_ROUTES } from '../../../constants/apiRoutes'
import { QUERY_KEYS } from '../../../constants/queryKeys'
import { SESSION_STORAGE } from '../../../constants/sessionStorage'

const request = async (payload: RunPetisSimulationClientRequest) => {
  const response = await api.post<RunPetisSimulationClientResponse>(
    API_ROUTES.runPetisSimulation,
    payload,
  )

  sessionStorage.setItem(
    SESSION_STORAGE.rpsQuoteId,
    response.data.runPetisSimulationResponse?.quoteId || '',
  )

  return response.data
}

export const useRunPetisSimulation = (
  payload: RunPetisSimulationClientRequest,
  enabled: boolean,
) => {
  return useQuery<
    RunPetisSimulationClientResponse,
    AxiosError<ErrorHandling[]>
  >({
    queryKey: [QUERY_KEYS.runPetisSimulation, payload],
    queryFn: () => request(payload),
    enabled,
  })
}
